<app-collection-form 
[title]="'pages.collections.configuration.header.title.create' | translate"
(submitForm)="handleSubmit($event)"
[submitLoading]="submitLoading">
</app-collection-form>